var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FF7A2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03555 2.28577C7.39976 2.28577 6.90356 2.62693 6.90356 3.23173C6.90356 5.07702 7.12062 7.72867 7.12062 9.57402C7.12067 10.0547 7.5394 10.2563 8.0356 10.2563C8.40775 10.2563 8.93498 10.0547 8.93498 9.57402C8.93498 7.72873 9.15204 5.07707 9.15204 3.23173C9.15204 2.62698 8.64035 2.28577 8.03555 2.28577Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05118 11.3262C7.36891 11.3262 6.85712 11.8689 6.85712 12.5202C6.85712 13.156 7.36886 13.7143 8.05118 13.7143C8.68696 13.7143 9.22974 13.156 9.22974 12.5202C9.22974 11.8689 8.68691 11.3262 8.05118 11.3262Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.4d1732b4c314609245baf855e3da9733.svg";
export { ForwardRef as ReactComponent };